<template>
  <div>
    <RedteaSIMWeb v-if="!isMobile"></RedteaSIMWeb>
    <RedteaSIMMobile v-if="isMobile"></RedteaSIMMobile>
  </div>
</template>
<script>
import RedteaSIMWeb from './Sim-web.vue'
import RedteaSIMMobile from './Sim-mobile.vue'
export default {
  name: 'RedteaSIM',
  data() {
    return {
      isMobile: true
    }
  },
  components: {
    RedteaSIMWeb,
    RedteaSIMMobile
  },
  mounted() {
    const detectDeviceType = () =>
      /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
        ? 'Mobile'
        : 'Desktop'
    this.isMobile = detectDeviceType() === 'Mobile'
  },
  methods: {}
}
</script>
<style lang="less">
</style>
